/**
 * RV9a · one operation type, authored with the designer.
 *
 * A type and a record are the same thing at two levels: a type is the template an operation
 * is built from, its sub-operations are the steps that template contributes. So this page is
 * the same `Designer` the record page mounts, fed by the type source — the sequence, the
 * step inspector, the rail, all one implementation. The rail has no process column because a
 * type has no process; the inspector shows the type's own facts where a record shows its
 * change control.
 *
 * A sub-operation is master data: a change here reaches every recipe built from the type.
 * The form says how many above every step, because that is the number an author needs
 * before making the change.
 */
import React, { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import Designer from "@/designer/Designer";
import { typeSource } from "./typeSource";

export default function OperationTypeView() {
  const { typeId } = useParams();
  // `?edit=1` — opened from a card's Edit (or just created): start in Edit rather than View.
  const [params] = useSearchParams();
  const edit = params.get("edit") === "1";
  const source = useMemo(() => typeSource(typeId, { edit }), [typeId, edit]);
  return <Designer source={source} />;
}
